<!-- <div class="download-banner">
  <app-download-banner></app-download-banner>
</div> -->

<vng-tabs [selectedIndex]="activeTabIndex" (selectedIndexChange)="handleNav($event)">
  <vng-tab label="Subscription">
    <div class="container subscription" style="display:flex; flex-direction:column">
      <!-- <h3 class="no-left-margin" style="margin-bottom: -0.5rem">
      Subscription
    </h3> -->
      <vng-card variant="outline" style="border: 1px solid #e9e9e9">
        <div class="card-title" style="display:flex; justify-content:flex-start; align-items:flex-start; gap:.5em">
          <h3 class="no-left-margin">Historic Usage</h3>
        </div>
        <div class="history-usage-parent">
          <app-history-usage style="overflow: hidden; display:flex; justify-content:space-between; gap:0.3em"
            class="history-usage-child" *ngIf="activeTabIndex === 0" [isGrowth]="isGrowthPlan"
            [isStarter]="isStarterPlan" [isFreemium]="isFreemiumPlan">
          </app-history-usage>
        </div>
      </vng-card>
      <vng-card variant="outline" *ngIf="!isCompanyUser" style="border: 1px solid #e9e9e9">
        <div class="card-title" style="display:flex; justify-content:flex-start; align-items:flex-start; gap:.5em">
          <h3 class="no-left-margin" style="margin-top: 0">FlyShare Rewards</h3>
        </div>
        <div>
          <app-flyshare-rewards> </app-flyshare-rewards>
        </div>
      </vng-card>
      <vng-card variant="outline" style="border: 1px solid #e9e9e9">
        <div class="info" style="display:flex; justify-content:space-between; align-items:center; gap:1em">
          <div>
            <p class="mb-small">
              Your current plan
              <strong>
                {{ planDisplayName$ | async }}
              </strong>
              <strong *ngIf="
                  currentPlanStatus === planStatus.Trial ||
                  currentPlanStatus === planStatus.Active ||
                  currentPlanStatus === planStatus.Paused ||
                  currentPlanStatus === planStatus.Incomplete
                " [class]="'sub-status-' + currentPlanStatus">{{
                currentPlanStatus === planStatus.Trial
                ? "14-day Trial Active"
                : planStatus.getNameByValue(currentPlanStatus)
                }}</strong>
            </p>
            <small *ngIf="ends_at && currentPlanStatus === planStatus.Trial" class="sub-billing">Your free 14-day trial
              will expire on {{ ends_at }}
            </small>
            <small *ngIf="ends_at && currentPlanStatus === planStatus.Active" class="sub-billing">Billing cycle renews
              in {{ ends_at }}
            </small>
            <small *ngIf="currentPlanStatus === planStatus.Paused" class="sub-billing">
              {{
              isGrowthPlan()
              ? "Your plan has been paused for 1 month."
              : "You are paid through the end of your bill cycle. Your subscription will pause billing at the beginning
              of the next bill cycle."
              }}
            </small>
          </div>

          <ng-container *ngIf="!isCompanyUser">
            <!--HubSpot Call-to-Action Code -->
            <span class="hs-cta-wrapper" id="hs-cta-wrapper-6ce7e4fa-c37f-41e9-bc0d-a2ab959b0b99"
              *ngIf="isFreemiumPlan()">
              <span>
                <!-- class="hs-cta-node hs-cta-6ce7e4fa-c37f-41e9-bc0d-a2ab959b0b99"
              id="hs-cta-6ce7e4fa-c37f-41e9-bc0d-a2ab959b0b99"
            > -->
                <!--[if lte IE 8]><div id="hs-cta-ie-element"></div><![endif]-->
                <button id="hs-cta-img-6ce7e4fa-c37f-41e9-bc0d-a2ab959b0b99" vng-button variant="primary"
                  (click)="upgradePlan()">
                  Upgrade Plan
                </button>
              </span>
            </span>
            <!-- end HubSpot Call-to-Action Code -->

            <!--HubSpot Call-to-Action Code -->
            <span class="hs-cta-wrapper" *ngIf="isStarterPlan()">
              <span>
                <!--[if lte IE 8]><div id="hs-cta-ie-element"></div><![endif]-->
                <button class="button" id="hs-cta-img-bdc772ba-cc33-484f-97d4-5bb380519902" vng-button variant="primary"
                  (click)="upgradePlan()">
                  Edit Plan
                </button>
              </span>
            </span>
            <!-- end HubSpot Call-to-Action Code -->

            <!--HubSpot Call-to-Action Code -->
            <span class="hs-cta-wrapper" *ngIf="isGrowthPlan()">
              <span>
                <!--[if lte IE 8]><div id="hs-cta-ie-element"></div><![endif]-->
                <button id="hs-cta-bdc772ba-cc33-484f-97d4-5bb380519902" vng-button variant="primary"
                  (click)="upgradePlan()">
                  Edit Plan
                </button>
              </span>
            </span>
            <!-- end HubSpot Call-to-Action Code -->
          </ng-container>
        </div>
      </vng-card>

      <vng-card variant="outline" *ngIf="roleplayAddOn" style="border: 1px solid #e9e9e9">
        <div class="info" style="display:flex; justify-content:space-between; align-items:center; gap:1em">
          <div>
            <p class="mb-small">
              Your RolePlay plan
              <strong>{{ roleplayAddOn.name }}</strong>
            </p>
            <small class="sub-billing">
              Billed ${{ roleplayAddOn.price }}/{{ roleplayBillingPeriod }} · managed in the FlyMSG RolePlay app
            </small>
          </div>
          <button vng-button variant="primary" (click)="manageRoleplaySubscription()">Manage Subscription</button>
        </div>
      </vng-card>

      <vng-card variant="outline" *ngIf="isNotFreemiumPlan()" style="display: none">
        <div class="info" style="display:flex; justify-content:space-between; align-items:center; gap:1em">
          <div>
            <h3 class="no-left-margin">Payment Details</h3>
            <p>View or edit your payment details</p>
          </div>
          <button vng-button variant="primary" (click)="editPaymentDetails()">Edit Payment Details</button>
        </div>

      </vng-card>
      <vng-card variant="outline" style="border: 1px solid #e9e9e9; display: none" *ngIf="isNotFreemiumPlan()">
        <div class="info" style="display:flex; justify-content:space-between; align-items:center; gap:1em">
          <div>
            <h3 class="no-left-margin">Invoices</h3>
            <p>View your payment history</p>
          </div>
          <button vng-button variant="primary" (click)="viewBillingHistory()">View Billing History</button>
        </div>
      </vng-card>
    </div>
  </vng-tab>

  <vng-tab label="Statistics">
    <div class="statistics">
      <h5 class="wpm-heading stat-title">User Preferences</h5>
      <section class="tw-flex tw-gap-4">
        <div class="tw-flex-[1] tw-p-2 tw-flex tw-flex-col tw-border tw-border-gray-200 tw-rounded-lg">
          <div class="tw-flex tw-gap-1 tw-items-center tw-justify-between">
            <vng-icon name="av_timer" color="accent" [outline]="false" class="timer-icon"></vng-icon>
            <p class="tw-text-xl tw-text-fpurple !tw-m-0">WPM (Words Per Minute)</p>
            <ng-template #popContent>This shows the number of words per minute that you type. You can determine your WPM
              <a href="https://www.livechat.com/typing-speed-test/#/" target="_blank"
                style="color: #fff; text-decoration: underline; font-weight: bold">here</a></ng-template>
            <vng-icon name="info" [outline]="false" class="tw-text-[18px]" color="accent" [ngbPopover]="popContent"
              popoverClass="popover-arrow-ml-0" [closeDelay]="5000" triggers="mouseenter:mouseleave"
              placement="top"></vng-icon>
          </div>
          <div class="tw-flex tw-gap-1 tw-items-center tw-mt-4" style="align-items: flex-start;">
            <!-- vng-input replaces the hand-styled raw number input. vng-input has no
                 min/step inputs; the "> 0" rule is enforced by saveWPM(), which also
                 coerces the (string) value back to a number for the API payload. -->
            <vng-input class="tw-w-full stat-value-input" type="number" [(ngModel)]="wordsPerMinute"
              [disabled]="!editWPM"></vng-input>

            <vng-icon name="edit" [outline]="false" vngTooltip="Edit  WPM" vngTooltipPosition="top"
              (click)="editWordPerMinute()" class="edit-icon" *ngIf="!editWPM"></vng-icon>
            <vng-icon name="check" [outline]="false" vngTooltip="Save WPM" vngTooltipPosition="top" class="check-icon"
              (click)="saveWPM()" *ngIf="editWPM"></vng-icon>
          </div>
        </div>
        <div class="tw-flex-[1] tw-p-2 tw-flex tw-flex-col tw-border tw-border-gray-200 tw-rounded-lg">
          <div class="tw-flex tw-gap-1 tw-items-center tw-justify-between" [ngStyle]="{
              opacity: wphOverrideUser ? 0.6 : 1,
              filter: wphOverrideUser ? 'grayscale(1)' : 'none'
            }">
            <vng-icon name="av_timer" color="accent" [outline]="false" class="timer-icon"></vng-icon>
            <p class="tw-text-xl tw-text-fpurple !tw-m-0">WPH (Wage Per Hour)</p>
            <ng-template #popContent>
              This shows your medium wage per hour. It's used to calculate the cost savings.
              <br />
              The changes you make here will affect only future calculations.
            </ng-template>
            <vng-icon name="info" [outline]="false" class="tw-text-[18px]" color="accent" [ngbPopover]="popContent"
              [closeDelay]="5000" triggers="mouseenter:mouseleave" placement="left"></vng-icon>
          </div>
          <div class="tw-flex tw-gap-1 tw-items-center tw-mt-4" style="align-items: flex-start;">
            <!-- vng-input replaces the hand-styled raw number input. vng-input has no
                 min/step inputs; the "> 0" rule is enforced by saveWPH(), which also
                 coerces the (string) value back to a number for the API payload. -->
            <vng-input class="tw-w-full stat-value-input" type="number" [(ngModel)]="wagePerHour"
              [disabled]="!editWPH || wphOverrideUser"></vng-input>

            <vng-icon name="edit" [outline]="false" vngTooltip="Edit WPH" vngTooltipPosition="top"
              (click)="editWagePerHour()" class="edit-icon" *ngIf="!editWPH"></vng-icon>
            <vng-icon name="check" [outline]="false" vngTooltip="Save WPH" vngTooltipPosition="top" class="check-icon"
              (click)="saveWPH()" *ngIf="editWPH"></vng-icon>
          </div>
          <ng-container *ngIf="wphOverrideUser">
            <em class="tw-mt-2 tw-text-gray-500">This setting is controlled by your administrator.</em>
          </ng-container>
        </div>
      </section>
      <hr class="hr" />

      <div class="charts-wrapper" [ngClass]="{ no_chart_height: !lineChartData?.labels.length }">
        <div class="stats-wrapper">
          <div class="stat">
            <div>
              <div class="stat-title">Time Saved (hrs)</div>
              <div class="flexed stat-content">
                <div class="stat-icon">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13.3335 7.7195C13.3335 10.8185 10.8185 13.3335 7.7195 13.3335C4.62056 13.3335 2.10547 10.8185 2.10547 7.7195C2.10547 4.62056 4.62056 2.10547 7.7195 2.10547C10.8185 2.10547 13.3335 4.62056 13.3335 7.7195Z"
                      stroke="#F0955C" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M9.80224 9.50469L8.06189 8.4661C7.75874 8.28645 7.51172 7.85417 7.51172 7.50048V5.19873"
                      stroke="#F0955C" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <p class="stat-value">
                  {{ (statistics?.time_saved ?? 0).toFixed(2) }}
                </p>
              </div>
            </div>
            <vng-icon name="info" [outline]="false" class="stat-info" color="accent"
              vngTooltip="This shows the total amount of time saved over the selected period of time"
              vngTooltipPosition="top"></vng-icon>
          </div>
          <div class="stat">
            <div>
              <div class="stat-title">Total FlyCuts Used</div>
              <div class="flexed stat-content">
                <div class="stat-icon">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5.05287 12.3511H8.42129C11.2283 12.3511 12.3511 11.2283 12.3511 8.42129V5.05287C12.3511 2.24585 11.2283 1.12305 8.42129 1.12305H5.05287C2.24585 1.12305 1.12305 2.24585 1.12305 5.05287V8.42129C1.12305 11.2283 2.24585 12.3511 5.05287 12.3511Z"
                      stroke="#FF9658" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M10.106 3.36865L3.36914 10.1055" stroke="#FF9658" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M10.105 5.61427V3.36865H7.85938" stroke="#FF9658" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M3.36914 7.85986V10.1055H5.61475" stroke="#FF9658" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
                <p class="stat-value">
                  {{ numberWithCommas(statistics?.flycuts_used) }}
                </p>
              </div>
            </div>
            <vng-icon name="info" [outline]="false" class="stat-info" color="accent" [vngTooltip]="
                'This shows the total amount of FlyCuts used over the selected period of time, If you signed up before 2023 this will show zero until we track your FlyCuts individually.'
              " vngTooltipPosition="top"></vng-icon>
          </div>
          <div class="stat">
            <div>
              <div class="stat-title">Characters Typed</div>
              <div class="flexed stat-content">
                <div class="stat-icon">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5.0518 12.3476H8.4193C11.2255 12.3476 12.348 11.2251 12.348 8.41881V5.05131C12.348 2.24506 11.2255 1.12256 8.4193 1.12256H5.0518C2.24555 1.12256 1.12305 2.24506 1.12305 5.05131V8.41881C1.12305 11.2251 2.24555 12.3476 5.0518 12.3476Z"
                      stroke="#F0955C" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3.92969 4.98949C5.69763 4.10832 7.77425 4.10832 9.54219 4.98949" stroke="#F0955C"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.73438 9.14835V4.45068" stroke="#F0955C" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
                <p class="stat-value">
                  {{ numberWithCommas(statistics?.characters_typed) }}
                </p>
              </div>
            </div>
            <vng-icon name="info" [outline]="false" class="stat-info" color="accent"
              vngTooltip="This shows the total amount of characters you typed over the selected period of time"
              vngTooltipPosition="top"></vng-icon>
          </div>
          <div class="stat">
            <div>
              <div class="stat-title">Cost Savings ($)</div>
              <div class="flexed stat-content">
                <div class="stat-icon">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13.3335 7.7195C13.3335 10.8185 10.8185 13.3335 7.7195 13.3335C4.62056 13.3335 2.10547 10.8185 2.10547 7.7195C2.10547 4.62056 4.62056 2.10547 7.7195 2.10547C10.8185 2.10547 13.3335 4.62056 13.3335 7.7195Z"
                      stroke="#F0955C" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M9.80224 9.50469L8.06189 8.4661C7.75874 8.28645 7.51172 7.85417 7.51172 7.50048V5.19873"
                      stroke="#F0955C" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <p class="stat-value">
                  {{ statistics?.cost_saved ?? 0 | currency }}
                </p>
              </div>
            </div>
            <vng-icon name="info" [outline]="false" class="stat-info" color="accent" [vngTooltip]="
                'This shows the total cost savings in USD over the selected period of time using the wage of $' +
                  statistics?.wage_per_hour
              " vngTooltipPosition="top"></vng-icon>
          </div>
        </div>

        <div class="chart-tabs">
          <div>
            <!-- R5: mat-select -> vng-select, data-driven (chartFilterVngOptions
                 getter). vng-select renders its own trigger chevron, so the
                 manual open/close arrow-icon pair + handleChange('general')
                 tracking is gone (nothing else read generalPanelOpen). -->
            <vng-select class="tab-select" [(ngModel)]="chartFilterKey" [options]="chartFilterVngOptions"
              (selectionChange)="chartFilter($event)"></vng-select>
          </div>
          <div>
            <vng-select class="tab-select" [(ngModel)]="dateFilterValue" [options]="dateRangeVngOptions"
              (selectionChange)="filterStatistics($event)"></vng-select>
          </div>
        </div>
        <div></div>
        <div class="chart">
          <div class="no-chart" *ngIf="!lineChartData?.labels?.length">
            <div class="bars">
              <div class="bar bar-1"></div>
              <div class="bar bar-2"></div>
              <div class="bar bar-3"></div>
            </div>
            <div class="no-chart-text">
              <p class="stat-text">This is where your statistics will appear</p>
              <!-- <p class="flycut-text">Let’s add your first FlyCut</p> -->
            </div>
          </div>
          <div *ngIf="lineChartData?.labels?.length">
            <canvas baseChart class="chart" [data]="lineChartData" [options]="lineChartOptions" [type]="lineChartType"
              (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)"
              style="height: 500px; width: 100%"></canvas>
          </div>
        </div>
      </div>
    </div>
  </vng-tab>

  <vng-tab label="Profile">
    <app-profile></app-profile>
  </vng-tab>

  <vng-tab label="Manage Categories">
    <div class="category-container">
      <div style="display:flex; justify-content:space-between; align-items:center">
        <h3 class="no-left-margin">
          Manage
          <span class="font-weight-bold">Categories</span>
        </h3>
        <div>
          <button vng-button onclick="this.blur()" variant="primary" (click)="shortcutCategoryRename({})">
            <!-- M12: vng-icon defaults to color="plum", which reads as dark ink on
                 the orange primary button — inherit the button's own colour. -->
            <vng-icon name="add" [outline]="false" color="inherit" class="right-space"></vng-icon>
            Add Category
          </button>
        </div>
      </div>

      <!-- R8: settings categories is a plain-array table (no matSort/mat-paginator
           ever existed here — 03-component-mapping.md row 29) — plain
           <table class="vng-table">, markup-only conversion. -->
      <div class="top-space" style="display:flex; flex-direction:column">
        <div class="vng-table-responsive" *ngIf="flattedCategories">
          <table class="vng-table min-width">
            <thead>
              <tr>
                <th>Category Name</th>
                <th class="col-shrink">FlyCuts</th>
                <th class="col-actions">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let element of flattedCategories">
                <td>
                  <span *ngIf="element.name1">
                    <span style="visibility: hidden">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  </span>
                  <span *ngIf="element.name2">
                    <span style="visibility: hidden">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  </span>
                  {{ element.name }}
                </td>
                <td class="col-shrink">
                  {{ element.shortcuts_count }}
                </td>
                <td class="col-actions">
                  <!-- M12: the row icons were both near-black (the sprite inherits
                       the default `fill`, the delete SVG hardcoded #231f20 via an
                       embedded <style> block that leaked `.st0` document-wide).
                       They now take their colour from the wrapper, matching the
                       persona table (purple edit / red delete). -->
                  <div class="category-row-actions" *ngIf="!element.is_default">
                    <svg-icon-sprite [vngTooltip]="'Update ' + tooltip(element)" vngTooltipPosition="top"
                      class="small-icon right-gap category-edit-icon" width="18px" height="18px" src="icon-ico-edit"
                      (click)="shortcutCategoryRename(element)">
                    </svg-icon-sprite>

                    <span class="category-delete-icon" (click)="deleteShortcutCategory(element)">
                      <svg style="height: 18px" id="icon-ico-delete" viewBox="0 0 32 32" fill="currentColor">
                        <g>
                          <path
                            d="M22.3,31.6H9.9c-2.3,0-4.2-1.9-4.3-4.2L2.6,6.4l1.7-0.3l3.1,21.1v0.1c0,1.4,1.1,2.6,2.6,2.6h12.3
                                          c1.4,0,2.6-1.1,2.6-2.6v-0.1l0-0.1l3.8-20.6l1.7,0.3l-3.8,20.5C26.5,29.7,24.6,31.6,22.3,31.6z" />
                        </g>
                        <g>
                          <path d="M28.6,7.7H4.3c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h24.3c0.6,0,1.2,0.3,1.6,0.7c0.4,0.4,0.6,1,0.6,1.6
                                          C30.9,6.7,29.9,7.7,28.6,7.7z M4.3,5C4.1,5,3.8,5.2,3.8,5.5C3.8,5.8,4.1,6,4.3,6h24.3c0.3,0,0.5-0.2,0.5-0.5v0
                                          c0-0.1-0.1-0.3-0.1-0.3C29,5.1,28.8,5,28.6,5L4.3,5L4.3,5z" />
                        </g>
                        <g>
                          <path d="M18.5,4.1h-4.2c-0.9,0-1.5-0.7-1.5-1.5V2c0-0.9,0.7-1.5,1.5-1.5h4.2C19.3,0.4,20,1.1,20,2v0.5
                                          C20,3.4,19.3,4.1,18.5,4.1z M14.3,1.9c-0.1,0-0.1,0.1-0.1,0.1v0.5c0,0.1,0.1,0.1,0.1,0.1h4.2c0.1,0,0.1-0.1,0.1-0.1V2
                                          c0,0-0.1-0.1-0.1-0.1H14.3z" />
                        </g>
                        <g>
                          <rect x="9.2" y="10.2" transform="matrix(0.9905 -0.1378 0.1378 0.9905 -2.4584 1.5384)"
                            width="1.4" height="16.6" />
                        </g>
                        <g>
                          <rect x="15.2" y="10.2" width="1.4" height="16.5" />
                        </g>
                        <g>
                          <rect x="14.3" y="17.8" transform="matrix(0.1359 -0.9907 0.9907 0.1359 1.1342 38.379)"
                            width="16.5" height="1.4" />
                        </g>
                      </svg>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </vng-tab>

  <vng-tab label="Persona">
    <app-user-persona></app-user-persona>
  </vng-tab>

  <vng-tab label="Extension Settings">
    <app-extension-settings #extensionSettings [settingsData]="list" [planId]="planId"></app-extension-settings>
  </vng-tab>

  <vng-tab label="Import FlyCuts">
    <div class="container">
      <div *ngIf="!isFlycutsImported" class="setting-block">
        <h3 class="no-left-margin">Import <span class="font-weight-bold">FlyCuts</span></h3>
        <p>
          Import your shortcodes from Text Blaze or TextExpander here. Simply drag and drop the file from your export
          below and we’ll take care of the rest.
        </p>
        <div draggable="true" style="border: 1px dashed #5f177f; border-radius: 4px" class="upload-area"
          (dragover)="$event.preventDefault()" (drop)="onFileDrop($event)">
          <!-- V3-17: 6px (was master's 11px). The drop zone is a fixed 174px box and
               the design-system type is taller than Material's was (p 16/24 vs 14/20,
               button 40px vs 36px), so the four rows filled 158 of the available
               150+22px and left nothing for the paragraph rhythm below. Trimming the
               inner padding buys back the 10px the `p` gutters need (see
               settings.component.scss `.upload-area p`) without changing the dashed
               box's own 174px geometry. -->
          <div
            style="display:flex; flex-direction:column; justify-content:space-around; align-items:center; padding: 6px 0">
            <img src="../../../assets/images/file_upload.png" alt="" srcset="" />
            <p style="margin-top: 8px">Drag and drop your file here</p>
            <p>or</p>
            <!-- V3-10: variant="secondary" paints `border-color: var(--vng-color-ink)`,
                 which .upload-btn's orange background could not hide — the button grew a
                 plum 1px stroke on all four sides. variant="primary" is the orange fill
                 (accent bg + white label + soft shadow) master rendered. -->
            <button vng-button variant="primary" class="upload-btn" (click)="file.click()">Choose File</button>
            <input type="file" #file [multiple]="false" style="display: none" (change)="uploadListener($event)"
              accept=".csv,.json" />
          </div>
        </div>
      </div>
      <div *ngIf="isFlycutsImported" class="setting-block">
        <!-- The page title and the Cancel/Import Selection pair share ONE row
             (title left, actions right, on a common centerline); the subtitle
             and the plan-restriction warning take the row below it. Was: title
             on its own line, then a space-between row that pushed the buttons
             down beside the subtitle. -->
        <div class="import-header">
          <h3 class="no-left-margin import-header__title">Import <span class="font-weight-bold">FlyCuts</span></h3>
          <div class="import-header__actions">
            <button vng-button variant="secondary" type="button" (click)="cancelImporting()">Cancel</button>
            <button vng-button variant="primary" type="button" (click)="importJSON()">
              <img src="assets/images/import.png" alt="" />
              Import Selection
            </button>
          </div>
        </div>
        <div class="import-subhead">
          <p>Select the Flycuts you want to import.</p>
          <div *ngIf="importRestrictionError">
            <p class="warn-txt">
              <img src="assets/images/warning.png" alt="" />
              Some of your FlyCuts can’t be imported.
            </p>
            <p>
              Please review the errors or
              <a href="/plans" class="import-upgrade-link">upgrade your plan.</a>
            </p>
          </div>
        </div>
        <div *ngIf="records.length" class="import-list">
          <vng-checkbox class="import-select-all" (click)="selectAll($event)" [checked]="allImportedChecked()">
            Select all
          </vng-checkbox>

          <!-- R15: mat-accordion multi -> plain div (all fe accordions are `multi`,
               so independent vng-expansion-panels need no coordination code).
               T3 (import): the hand-rolled header/body markup this block used to
               carry is now the shared app-flymsg-row-header / app-flymsg-row-editor
               pair that FlyCuts, FlyPlates and the dashboard row already use — so
               the preview rows here get the same card, the same 35px expanded
               strip and the same chevron alignment (both keyed off
               `app-flymsg-row-header` in app.scss) instead of a second, drifted
               copy of that layout.
               The checkbox + number badge live in the left gutter, exactly as on
               FlyCuts (shortcuts.component.html): as siblings of the panel they
               keep their place on the row's centerline and stay visible while the
               row is expanded — master needed a SECOND checkbox inside the body
               for that, and the migrated copy had left the first one floating
               above the card. -->
          <div class="vng-accordion">
            <div class="import-row" *ngFor="let shortcut of records; let i = index">
              <div class="import-row__gutter">
                <vng-checkbox color="primary" [(ngModel)]="shortcut.checked"></vng-checkbox>
                <p class="number" [ngClass]="{ 'number--error': shortcut.error }">{{ i + 1 }}</p>
              </div>

              <vng-expansion-panel
                class="import-panel"
                [ngClass]="{ 'warn-border': shortcut.error }"
                (opened)="panelOpenState[i] = true"
              >
                <app-flymsg-row-header
                  vngExpansionHeader
                  [name]="shortcut.shortcut"
                  [title]="shortcut.title"
                  [descriptionHtml]="getHtml(shortcut) || 'First line of content appears here...'"
                  [showUsageBadge]="false"
                  [errorText]="shortcut.error || ''"
                ></app-flymsg-row-header>

                <app-flymsg-row-editor
                  [flyCutValue]="shortcut.shortcut"
                  (flyCutValueChange)="shortcut.shortcut = $event"
                  [flyCutRequired]="false"
                  flyCutHelpText="This is a shortcode or a keyboard shortcut that you’ll type when you want the content in the FlyMSG section below to be inserted onto any enabled web platform."
                  [showTryItOut]="false"
                  [titleValue]="shortcut.title"
                  (titleValueChange)="shortcut.title = $event"
                  [titleRequired]="false"
                  [showVersionColumn]="false"
                  [showActionSelect]="false"
                  [showSavingNote]="false"
                  [showDuplicate]="false"
                  [showChangeCategory]="false"
                  [errors]="shortcut.error ? [shortcut.error] : []"
                  (delete)="deleteShortcut(shortcut, i)"
                >
                  <editor
                    editor
                    [apiKey]="editorApiKey"
                    [cloudChannel]="'8'"
                    id="shortcut{{ i }}"
                    [init]="editorConfig"
                    *ngIf="editorConfig && panelOpenState[i]"
                    [(ngModel)]="shortcut.html"
                    (ngModelChange)="checkImportedShortcutsRestriction()"
                    [ngModelOptions]="{ standalone: true }"
                  >
                  </editor>
                </app-flymsg-row-editor>
              </vng-expansion-panel>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="activeImportConflictRows.length" class="import-duplicate-dialog" role="dialog" aria-modal="true" aria-label="Import FlyCut conflicts">
        <h3>{{ libraryConflictRows.length ? 'FlyMSG with the same FlyCut is already stored in your library.' : 'Duplicate FlyCuts detected' }}</h3>
        <p>{{ libraryConflictRows.length ? 'Preview, edit, delete, replace, or retry the incoming FlyCuts.' : 'The selection contains FlyMSGs with the same FlyCut. Edit or delete the affected rows, then try again.' }}</p>
        <div class="import-duplicate-dialog__rows" role="table" aria-label="Conflicting FlyCuts">
          <div class="import-duplicate-dialog__row import-duplicate-dialog__row--head" role="row">
            <span role="columnheader">FlyCut</span>
            <span role="columnheader">Title/Description</span>
            <span role="columnheader">Actions</span>
          </div>
          <div *ngFor="let shortcut of activeImportConflictRows" class="import-duplicate-dialog__row" role="row">
            <ng-container *ngIf="isEditingImportRow(shortcut); else importRowReadOnly">
              <input [(ngModel)]="shortcut.shortcut" aria-label="FlyCut" />
              <input [(ngModel)]="shortcut.title" aria-label="Title or description" />
            </ng-container>
            <ng-template #importRowReadOnly>
              <span>{{ shortcut.shortcut }}</span>
              <span>{{ shortcut.title }}</span>
            </ng-template>
            <button vng-button variant="secondary" type="button" (click)="previewDuplicate(shortcut)">Preview</button>
            <button vng-button variant="secondary" type="button" *ngIf="!isEditingImportRow(shortcut)" (click)="editImportRow(shortcut)">Edit</button>
            <button vng-button variant="secondary" type="button" *ngIf="isEditingImportRow(shortcut)" (click)="saveImportRow(shortcut)">Save</button>
            <button vng-button variant="secondary" type="button" (click)="skipDuplicate(shortcut)">Delete</button>
            <span *ngIf="shortcut.error" class="import-duplicate-dialog__error" role="alert">{{ shortcut.error }}</span>
          </div>
        </div>
        <button vng-button variant="secondary" type="button" [disabled]="importSubmitting" (click)="dismissImportConflicts()">Cancel</button>
        <button vng-button variant="primary" type="button" *ngIf="libraryConflictRows.length" [disabled]="importSubmitting" (click)="replaceLibraryConflicts()">Replace</button>
        <button vng-button variant="primary" type="button" [disabled]="importSubmitting" (click)="libraryConflictRows.length ? retryLibraryImport() : retryDuplicateImport()">Try Again</button>
      </div>
    </div>
  </vng-tab>

  <!-- 08 §12: "Manage Your Teams" tab stays commented out / must NOT appear post-migration.
       (Was a Material tab hosting a card with "Manage your Pro Team Plan Here" — left disabled,
       not ported, per feature-parity checklist; intentionally not written as real markup here so
       it can never be un-commented back into a live tab by accident.) -->
</vng-tabs>
